# This service is the only point in the application which needs to be modified
# to add derivative converters. A converter should ONLY be added as an inline
# array annotation.

angular.module('rjmNg.services').factory 'rjdlDefinitionInjector', [
  'AgeDefinition'
  'JoinDefinition'
  'AggregateDefinition'
  'CalculationDefinition'
  'DateDiffDefinition'
  'EventNumberDefinition'
  'SequentialEventCompDefinition'
  'CurrencyConverterDefinition'
  # We don't reference the dependencies by name, so we don't have to add
  # them as function parameters
  () ->

    # arguments is a list of definition converters
    converters = arguments

    rjdlDefinitionInjectorService =

      getConverters: () ->
        _.filter converters, (converter) ->
          converter.isSupported()

      getConverterForType: (derivativeType, column = null) ->
        _.find converters, (converter) ->
          converter.definition is derivativeType and converter.isSupported(column)

]
